import React, { Fragment, useState, useEffect } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import GetAdminService from "../../../services/admin/GetAdminService";
import CustomPagination from "../../pagination/Pagination";
import { useHistory } from "react-router-dom";
import CustomLoader from "../../customLoader/CustomLoader";
import swal from "sweetalert";
import "./StudentProgress.css";
import Loader from "react-loader-spinner";

const RequiredCourseSet = () => {
  let history = useHistory();
  const [requiredCourseData, setRequiredCourseData] = useState();
  const [coursePageData, setCoursePageData] = useState();
  const [page, setPage] = useState(1);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [deletedCourseId, setDeletedCourseId] = useState();
  const [loading, setLoading] = useState(false);
  const [publishedButtonIndex, setPublishedButtonIndex] = useState(-1);
  const [publishedLoading, setPublishedLoading] = useState(false);

  const getCourseData = () => {
    setLoading(true);
    let obj = {
      page: page,
      role: "admin"
    };
    GetAdminService.coursePage(obj)
    .then((data) => {
      setCoursePageData(data?.data);
      setRequiredCourseData(data?.data);
      let convertedData = DataMapping(data?.data?.result);
      if (convertedData?.length > 0) {
        setConvertedDataToCoursepageData(convertedData);
      }
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
    });
  };

  const DataMapping = (value) => {
    for (var i = 0; i < value.length; i++) {
      for (var j = 0; j < value[i].publish_data.length; j++) {
        if (value[i].publish_data[j].school_id === user.school_id) {
          value[i].published = value[i].publish_data[j].published;
          value[i].data = value[i].publish_data[j].data_mapped_percentage;
        }
      }
    }
    return value;
  };

  const setConvertedDataToCoursepageData = (data) => {
    if (data) {
      setCoursePageData({ ...coursePageData, result: data });
    }
  };

  const deleteCourseRequirementhandler = (item) => {
    const courseId = item?.id;
    setDeletedCourseId(courseId);
    let obj = {
      course_id: courseId
    };
    GetStudentService.deleteCourseRequirement(obj)
    .then(async () => {
      const confirmed = await swal({
        title: "Delete?",
        text: "Are you sure you want to delete?",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "OK"
        },
        dangerMode: true,
        closeOnClickOutside: false
      });
      if (confirmed) {
        deleteCourseAfterRequirement(courseId);
      }
    })
    .catch(() => {});
  };

  const deleteCourseAfterRequirement = (courseId = deletedCourseId) => {
    let obj = {
      deleted: true
    };
    GetStudentService.deleteCourse(obj)
    .then(() => {
      courseDeleteConfirmation(courseId);
    })
    .catch(() => {});
  };










  const courseDeleteConfirmation = (value) => {
    let obj = {
      delete_course_id: value
    };
    GetStudentService.deleteCourseConfirmation(obj)
    .then(() => {
      setDeletedCourseId();
      getCourseData();
    })
    .catch(() => {});
  };

  const undoDelete = (value) => {
    let obj = {
      course_id: value?.id,
      deleted: "True"
    };
    GetStudentService.undoCourseDelete(obj)
    .then(() => {
      getCourseData();
    })
    .catch(() => {});
  };

  useEffect(() => {
    getCourseData();
  }, [page]);

  const publishOrUnpublishCourse = (item, index, publishValue) => {
    setPublishedLoading(true);
    setPublishedButtonIndex(index);
    let obj = {
      course_id: item?.id,
      inter_published: publishValue
    };
    GetAdminService.coursePublished(obj)
    .then(() => {
      setPublishedLoading(false);
      getCourseData();
    })
    .catch(() => {
      setPublishedLoading(false);
    });
  };

  const handleDuplicateCourse = (item) => {
    let obj = {
      clone_id: item?.id
    };
    GetStudentService.duplicateCourse(obj)
    .then((data) => {
      history.push(`/admin/course/${data?.data?.new_id}`);
    })
    .catch(() => {});
  };

  const handleCourseEdit1 = () => {
    swal({
      text: `Conceal Course cannot be edited. Kindly Broadcast the Course to edit.`,
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: true
      },
      closeOnClickOutside: false
    });
    setPublishedLoading(false);
  };

  const handleCourseEdit = (item) => {
    history.push(`/admin/course/${item?.id}`);
  };




















  const renderPublishSpinner = (index) =>
  publishedButtonIndex === index && publishedLoading ?
  <Loader type="TailSpin" color="white" height={16} width={16} /> :
  null;

  return (
    <Fragment>
      <div className="admin-ccplus-panel-header">
        <div>
          <h2 className="admin-ccplus-panel-title">Required Course Set</h2>
          <p className="admin-ccplus-panel-hint">
            Create, broadcast, and manage course requirements
          </p>
        </div>
        <button
          onClick={() => history.push("/admin/course")}
          className="admin-ccplus-btn primary toolbar">
          
          New Required Course Set
        </button>
      </div>

      {loading ?
      <div className="admin-ccplus-list-loading">
          <CustomLoader variant="inline" color="#007bff" size={42} />
        </div> :

      <div className="admin-ccplus-list">
          {coursePageData?.result?.length > 0 ?
        coursePageData.result.map((item, index) =>
        <div
          key={item?.id || index}
          className={`admin-ccplus-item ${item?.deleted ? "is-deleted" : ""}`}>
          
                <div className="admin-ccplus-item-main">
                  <p className="admin-ccplus-item-name">{item?.name}</p>
                  <div className="admin-ccplus-item-meta">
                    {item?.deleted ?
              <span className="admin-ccplus-badge deleted">Deleted</span> :
              item?.inter_published ?
              <span className="admin-ccplus-badge broadcast">Broadcasted</span> :

              <span className="admin-ccplus-badge conceal">Concealed</span>}
              
                  </div>
                </div>

                <div className="admin-ccplus-item-actions">
                  {item?.deleted === true &&
            <button
              onClick={() => undoDelete(item)}
              className="admin-ccplus-btn danger">
              
                      Undo
                    </button>}
            

                  {item.inter_published && item.deleted === false ?
            <button
              onClick={() =>
              publishOrUnpublishCourse(item, index, "False")}

              className="admin-ccplus-btn conceal">
              
                      Conceal Course
                      {renderPublishSpinner(index)}
                    </button> :
            !item?.inter_published && item.deleted === false ?
            <button
              className="admin-ccplus-btn broadcast"
              onClick={() =>
              publishOrUnpublishCourse(item, index, "True")}>

              
                      Broadcast Course
                      {renderPublishSpinner(index)}
                    </button> :
            null}

                  {item?.deleted === false &&
            <button
              onClick={() => handleDuplicateCourse(item)}
              className="admin-ccplus-btn primary">
              
                      Duplicate
                    </button>}
            

                  {item?.deleted === false && item?.inter_published === false ?
            <button
              className="admin-ccplus-btn secondary"
              onClick={() => handleCourseEdit(item)}>
              
                      Edit
                    </button> :

            <button
              onClick={() => handleCourseEdit1()}
              className="admin-ccplus-btn secondary">
              
                      Edit
                    </button>}
            

                  {item?.deleted === false &&
            <button
              onClick={() => deleteCourseRequirementhandler(item)}
              className="admin-ccplus-btn primary">
              
                      Delete
                    </button>}
            
                </div>
              </div>
        ) :

        <p className="admin-ccplus-empty">No required course sets found</p>}
        
        </div>}
      

      <div className="admin-ccplus-pagination">
        <CustomPagination
          count={requiredCourseData}
          pageValue={page}
          setPage={setPage} />
        
      </div>
    </Fragment>);

};

export default RequiredCourseSet;